export class DashboardIndicadores {
  turmasAtivas = 0;
  matriculasEmTurmasAtivas = 0;
  /** Catequizandos distintos matriculados em turmas ativas (denominador do card de presenças). */
  pessoasMatriculadasDistintasEmTurmasAtivas = 0;
  pessoasComPresencaSemanaAnterior = 0;
  turmasComFrequenciaSemanaAnterior = 0;
  semanaAnteriorInicio?: string;
  semanaAnteriorFim?: string;

  constructor(data?: Partial<DashboardIndicadores>) {
    if (data) Object.assign(this, data);
  }
}
